import type { IconData } from '@stacksjs/iconify-core'

export const brailleBlind: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M32.528 45a24.46 24.46 0 0 0 2.948-12.751c-.1-2.223-1.553-4.105-3.663-4.81c-4.373-1.462-8.439-1.462-8.439-1.462c0-1.808-.282-5.936-.484-8.663c-.118-1.587-1.175-2.974-2.751-3.196c-.5-.07-1.035-.118-1.572-.118c-.54 0-1.078.048-1.578.12c-1.563.222-2.611 1.595-2.716 3.17a222 222 0 0 0-.493 14.324s-1.712-1.341-4.34-2.955c-1.353-.83-3.095-.895-4.125.314a7.9 7.9 0 0 0-1.57 2.956c-.201.695-.038 1.43.365 2.03C5.579 36.148 9.534 41.669 14.139 45M3 16a3 3 0 1 0 6 0a3 3 0 1 0-6 0m25 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0m17 0a3 3 0 1 1-6 0a3 3 0 1 1 6 0m0-10a3 3 0 1 1-6 0a3 3 0 1 1 6 0M15.5 6a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default brailleBlind
